import Avatar from '@material-ui/core/Avatar';
import LinearProgress from '@material-ui/core/LinearProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import PersonIcon from '@material-ui/icons/Person';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import useTypedSelector from '../../hooks/useTypedSelector';

export default function BirthdayMonth() {
  const [birthday, setBirthday] = useState('');
  const [cont, setCont] = useState(false);
  const people = useTypedSelector(({ peopleState }) => peopleState.people);
  const searchQuery = useTypedSelector(
    ({ peopleState }) => peopleState.searchQuery
  );

  const peopleBirthday = () => {
    const dateToFormat = new Date();
    const today = moment(dateToFormat).format('MM');
    setBirthday(today);
  };

  useEffect(() => {
    peopleBirthday();
  });

  const filteredPeople = useMemo(() => {
    return people.filter((person) => {
      let birthdayPerson = person.birthday
        ? moment(person.birthday, 'YYYY-MM-DD').format('MM')
        : '';

      if (birthday === birthdayPerson) {
        setCont(true);
        return person.name.toLowerCase();
      }
      return false;
    });
  }, [birthday, people]);

  const { selectedIndex, isEditing, isLoading } = useTypedSelector(
    ({ peopleState }) => {
      return {
        selectedIndex: peopleState.selectedIndex,
        isEditing: peopleState.isEditing,
        isLoading: peopleState.loadingPeople,
      };
    }
  );

  const renderListItem = (person: any, i: number) => (
    <ListItem
      key={i}
      selected={!searchQuery && isEditing && selectedIndex === i}
    >
      <ListItemAvatar>
        {person.image ? (
          <Avatar alt={`Foto de ${person.name}`} src={person.image.sm} />
        ) : (
          <Avatar>
            <PersonIcon />
          </Avatar>
        )}
      </ListItemAvatar>
      <ListItemText
        primary={person.name}
        secondary={
          person.birthday
            ? moment(person.birthday, 'YYYY-MM-DD').format('DD/MM/2020')
            : ''
        }
      />
    </ListItem>
  );

  if (isLoading) {
    return (
      <>
        <LinearProgress />
      </>
    );
  }

  return (
    <>
      {!cont ? (
        <div>
          <List>
            <ListItem>
              <ListItemText
                primary="Sem aniversariantes"
                secondary="Caso tenha alguém fazendo aniversario verifica a data de nascimento no cadastro de membros"
              />
            </ListItem>
          </List>
        </div>
      ) : (
        <>
          <List>{filteredPeople.map(renderListItem)}</List>
        </>
      )}
    </>
  );
}
